import { render, staticRenderFns } from "./SkuTitle.vue?vue&type=template&id=3ee49b0d&scoped=true&"
import script from "./SkuTitle.vue?vue&type=script&lang=ts&"
export * from "./SkuTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SkuTitle.vue?vue&type=style&index=0&id=3ee49b0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee49b0d",
  null
  
)

export default component.exports